import BaseStore from '@/store/base-store'

export default new BaseStore('trackings')



// WEBPACK FOOTER //
// ./src/store/modules/trackings.store.js